import type { CandidatePhoto } from '../types';

type CandidateFileType = NonNullable<CandidatePhoto['type']>;

export function mockCandidateFileType(
  overrides: Partial<CandidateFileType> = {}
): CandidateFileType {
  return {
    value: 'image',
    name: 'Image',
    ...overrides,
  };
}
